module.exports = __webpack_public_path__ + "static/media/LTS.3431ba44.png";